import type { SVGProps } from 'react';

// Figma draws the "outline" star as a single filled donut shape (outer 5-star path
// plus an inner anti-star path, combined with `fill-rule="evenodd"`). This means
// the icon is fully covered by the filled star at 100% fill, with no leftover grey
// stroke around the perimeter.
const OUTLINE_STAR_PATH =
    'M8.00002 0C8.21811 0 8.41422 0.132774 8.49521 0.335258L10.4944 5.33333H15.4667C15.6889 5.33333 15.8878 5.47108 15.9659 5.67908C16.0441 5.88707 15.9851 6.12173 15.8179 6.26804L11.8024 9.78162L13.3146 15.3263C13.375 15.5478 13.2869 15.7831 13.0959 15.9104C12.9049 16.0378 12.6538 16.0286 12.4726 15.8877L8.00002 12.409L3.52746 15.8877C3.34625 16.0286 3.09519 16.0378 2.90418 15.9104C2.71318 15.7831 2.62508 15.5478 2.68548 15.3263L4.19768 9.78162L0.182155 6.26804C0.0149389 6.12173 -0.044048 5.88707 0.0341026 5.67908C0.112253 5.47108 0.311166 5.33333 0.533357 5.33333H5.50561L7.50484 0.335258C7.58583 0.132774 7.78194 0 8.00002 0ZM8.00002 1.96938L6.36188 6.06474C6.28088 6.26723 6.08477 6.4 5.86669 6.4H1.9528L5.15123 9.19863C5.30486 9.33305 5.36828 9.54338 5.31456 9.74033L4.13555 14.0634L7.67259 11.3123C7.86518 11.1626 8.13487 11.1626 8.32746 11.3123L11.8645 14.0634L10.6855 9.74033C10.6318 9.54338 10.6952 9.33305 10.8488 9.19863L14.0473 6.4H10.1334C9.91527 6.4 9.71916 6.26723 9.63817 6.06474L8.00002 1.96938Z';

export const StarOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
        fill="currentColor"
        aria-hidden="true"
        focusable="false"
        {...props}>
        <path fillRule="evenodd" clipRule="evenodd" d={OUTLINE_STAR_PATH} />
    </svg>
);
